module.exports = __webpack_public_path__ + "img/pdf.745565a9.jpg";